import type { CreateMessageDto } from "@/interfaces/message/message";
import { makeRequest } from "@/utils/makeRequest";

export const tradeApi = {
  getTrade: async (tradeId: string) => makeRequest.get(`/trade/${tradeId}`),

  markAsPaid: async (tradeId: string) =>
    makeRequest.put(`/trade/${tradeId}/complete`),

  releaseTrade: async (
    tradeId: string,
    payload: {
      otp: string;
      securityCode: string;
    },
  ) => makeRequest.put(`/trade/${tradeId}/release`, payload),

  cancelTrade: async (tradeId: string) =>
    makeRequest.put(`/trade/${tradeId}/cancel`),

  openDispute: async (
    tradeId: string,
    payload: { reason: string; image?: string },
  ) => makeRequest.put(`/trade/${tradeId}/dispute`, payload),

  sendMessage: async (dto: CreateMessageDto) =>
    makeRequest.post("/trade/message", dto),
};
